<template>
    <Title :level="1" class="page-title">
        <template v-if="!isEditing">
            {{ model ? model.name : "..." }}
        </template>
        <InputText v-else-if="model" type="text" v-model="model.name" />
    </Title>
</template>

<script lang="ts" setup>
import Title from "@/components/Title.vue";
import { useEditManager } from "@/composables/edit-manager";

const model = defineModel<{
    name: string;
}>();

defineProps<{
    icon?: string;
}>();

const { isEditing } = useEditManager();
</script>

<style lang="scss" scoped>
.page-title {
    width: 100%;
    margin-bottom: 0;
    display: flex;
    margin-right: 0.5rem;

    .p-inputtext {
        flex-grow: 1;
        font-size: 1em; // It's already inside the h1 tag
        font-weight: bold;
        color: var(--text-color);
        padding: 0;
    }
}
</style>
